//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { theme } from '@bvengineering/unison-core';

import { getEchoThemeComponents } from '@utils/themeUtils';

const iconTheme = getEchoThemeComponents(theme).icon;

// Icon size constants
export const SM_SIZE = parseInt(iconTheme.size.sm, 10);
export const DEFAULT_SIZE = parseInt(iconTheme.size.md, 10);
export const LG_SIZE = parseInt(iconTheme.size.lg, 10);

// The minimum height for the YouTube logo according to their branding guidelines is 20px.
// Since the logo is wider than it is tall, we need to set a size of 27px in order for the
// height to be at least 20px.
// https://www.youtube.com/howyoutubeworks/resources/brand-resources/#logos-icons-and-colors
export const YOUTUBE_ICON_MIN_SIZE = parseInt(iconTheme.size.youtubeMin, 10);

// YouTube icons must be one of the approved colors according to YouTube's branding guidelines
// https://www.youtube.com/howyoutubeworks/resources/brand-resources/#logos-icons-and-colors
export const YOUTUBE_RED_ICON_COLOR = iconTheme.color.youtubeRed;
export const YOUTUBE_GRAY_ICON_COLOR = iconTheme.color.youtubeGray;

// https://about.instagram.com/brand/gradient
export const INSTAGRAM_ICON_COLOR = iconTheme.color.instagram;

export const FACEBOOK_ICON_COLOR = iconTheme.color.facebook;

export const PINTEREST_ICON_COLOR = iconTheme.color.pinterest;

export const TWITTER_ICON_COLOR = iconTheme.color.twitter;

export const TIKTOK_ICON_COLOR = iconTheme.color.tiktok;
